import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface xiaohongshuWebRelationParams extends ActiomCommonParams {
    action: "follow" | "unfollow"; // 关系操作类型
    target_user_id: string; // 目标用户ID
}

export interface RelationResponse {
    code: number;
    success: boolean;
    msg: string;
    data: RelationDetail;
}

export interface RelationDetail {
    fstatus: string | null;
}

export type PublishAction = CommonAction<xiaohongshuWebRelationParams, RelationDetail | Record<string, never>>;

export const xiaohongshuWebRelationAction: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(414, "用户关系操作失败", {});
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };

    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: {} };
    if (!params.action || !params.target_user_id) {
        return { code: 414, message: "参数缺失，请检查后重试！", data: {} };
    }

    const relationParams = {
        target_user_id: params.target_user_id,
    };

    let relationActionRes: RelationResponse;
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    switch (params.action) {
        case "follow": {
            const followMentions = "/api/sns/web/v1/user/follow";
            const followXsHeader = xsEncrypt.signHeadersPost(
                followMentions,
                recordCookie,
                "xhs-pc-web",
                relationParams,
            );

            relationActionRes = await http.api<RelationResponse>(
                {
                    method: "post",
                    url: "https://edith.xiaohongshu.com/api/sns/web/v1/user/follow",
                    data: relationParams,
                    headers: followXsHeader,
                },
                { retries: 3, retryDelay: 500, timeout: 3000 },
            );
            break;
        }

        case "unfollow": {
            const unfllowMentions = "/api/sns/web/v1/user/unfollow";
            const unfllowXsHeader = xsEncrypt.signHeadersPost(
                unfllowMentions,
                recordCookie,
                "xhs-pc-web",
                relationParams,
            );

            relationActionRes = await http.api<RelationResponse>(
                {
                    method: "post",
                    url: "https://edith.xiaohongshu.com/api/sns/web/v1/user/unfollow",
                    data: relationParams,
                    headers: unfllowXsHeader,
                },
                { retries: 3, retryDelay: 20, timeout: 3000 },
            );
            break;
        }

        default:
            return { code: 414, message: "参数action错误，请重试！", data: {} };
    }

    const isSuccess = relationActionRes.code === 0;
    const message = `用户关系操作${isSuccess ? "成功" : `失败，原因：${relationActionRes.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? relationActionRes.data : { fstatus: null };

    return response(isSuccess ? 0 : 414, message, data);
};
